<template>
  <section>
    <header-com />
    <div class="topTips"
         v-if="detail.promptBox">{{detail.promptBox}}</div>
    <div class="topMsg">
      <img :src="detail.pic | formatImgUrl(164,164,true)" />
      <div class="msg">
        <div class="name">{{detail.goodsName}}</div>

        <div class="speed"
             v-if="detail.diagnosisOrComplete === 'diagnosis'&&detail.rateOfProgress<=1&&detail.rateOfProgress!==null">
          <div class="speedBox">
            <van-progress :show-pivot='false'
                          color="#7ADFDF"
                          :percentage="detail.rateOfProgress*100" />
          </div>
          <div class="speedNum">{{Math.round(detail.rateOfProgress*100)}}%</div>
        </div>
        <div class="time"
             v-if="detail.diagnosisOrComplete === 'diagnosis'&&detail.rateOfProgress<=1&&detail.rateOfProgress!==null">预计<span class="yesColor">{{detail.endTime}}</span>完工，剩余<span class="yesColor">{{detail.remianDays}}</span>天</div>

        <div class="speed"
             v-if="detail.diagnosisOrComplete === 'diagnosis'&&detail.rateOfProgress>1&&detail.rateOfProgress!==null">
          <div class="speedBox2">
            <van-progress :show-pivot='false'
                          color="#7ADFDF"
                          :percentage="95" />
          </div>
        </div>
        <!-- <span style="color:#F24949"></span> -->
        <div class="time" v-if="detail.diagnosisOrComplete === 'diagnosis'&&detail.rateOfProgress>1&&detail.rateOfProgress!==null">
            预计<span class="yesColor">{{detail.endTime}}</span>完工，当前已超期<br>
            还得<span class="yesColor">{{detail.remianDays}}</span>天就可以完成了，工匠老师们正在抓紧哦!
        </div>

        <div class="speed"
             v-if="detail.diagnosisOrComplete === 'complete'">
          <div class="speedBox">
            <van-progress :show-pivot='false'
                          track-color="#ECF0F1"
                          color="#7ADFDF"
                          :percentage="100" />
          </div>
          <div class="speedNum">100%</div>
        </div>

      </div>
    </div>


    <div style="width: 100%;overflow: hidden;">
      <button class="primary myBtn" size="small" @click="reminderFn">催单</button>
    </div>

    <div class="content">

      <div style="width:100%"
           class="myBox"
           v-for="(item,index) of speedList"
           :key="index">
        <div class="firstTitle">
          <img class="firstComplete"
               v-if="item.status !== 1"
               src="/images/order/first_complate.png" />
          <img class="firstComplete"
               v-if="item.status === 1"
               src="/images/order/first_noComplate.png" />
          <div class="text">{{item.curingServiceName}}</div>
        </div>

        <div :class="index==speedList.length-1?'secondBigBox secondBigBox_last':'secondBigBox'"
             v-for="(item2,index2) of item.goodsTechnics"
             :key="index2">
          <div class="secondBox"
               @click="detailShowFn(index,index2)">
            <div class="title">
              <div class="leftName">{{item2.technicName}}</div>
              <img src="/images/order/second_jiantou.png"
                   :class="item2.detailShow?'imgRotate':''" />
              <div v-if="item2.status === 1" class="rightName textGray">{{item2.statusVal}}</div>
              <div v-if="item2.status !== 1" class="rightName yesColor">{{item2.statusVal}}</div>
            </div>

            <div class="thirdBigBox"
                 v-if="item2.detailShow">

              <div class="thirdBox"
                   v-for="(item3,index3) of workList"
                   :key="index3">
                <div class="thirdTitle">
                  <img class="thirdImg"
                       v-if="(item2.workProcessLogs.length-1 >= index3 && index3!=2) || item2.workProcessLogs.length-1 > 2"
                       src="/images/order/third_yes.png" />
                  <img class="thirdImg"
                       src="/images/order/third_doing.png"
                       v-else-if="item2.workProcessLogs.length-1 == 2 && index3==2" />
                  <img class="thirdImg"
                       src="/images/order/third_no.png"
                       v-else />
                  <div :class="item2.workProcessLogs.length-1>=index3?'thirdText yesColor':'thirdText'">{{item3.name}}</div>
                </div>
                <div :class="index3==4?'thirdTips_last':'thirdTips'">
                  {{index3==2?

                    (item2.workProcessLogs.length-1>=2 && item2.workProcessLogs[2].operatorName? item2.workProcessLogs[2].operatorName+'师傅正在修复中' :

                      item2.workProcessLogs.length-1>=3 && item2.workProcessLogs[3].operatorName ? item2.workProcessLogs[3].operatorName+'师傅正在修复中' : item3.tips)

                  :item3.tips}}
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

    </div>

  </section>
</template>

<script>
import orderApi from '@/axios/order'
import { Toast } from 'vant';
export default {
  name: 'index',
  computed: {
  },
  data() {
    return {
      id: this.$route.query.id,
      speedList: [],
      workList: [
        {
          name: '生产开始',
          tips: '分拣人员按照工艺路线进行拣货'
        }, {
          name: '分拣完成',
          tips: '已经将物品分拣至师傅手中'
        }, {
          name: '修复中',
          tips: '正在等待师傅修复...'
        }, {
          name: '修复完成',
          tips: ''
        }, {
          name: '质检合格',
          tips: '质检人员根据诊断方案完成修复效果检查'
        },
      ],
      detail: {}
    }
  },
  created() {
    this.getDetail()
    console.log(0.29 * 100)
  },
  mounted() {

  },
  methods: {
    reminderFn() {
      if(this.detail.diagnosisOrComplete === 'diagnosis'&&this.detail.rateOfProgress<=1&&this.detail.rateOfProgress!==null) {
        Toast('心爱之物的修复在正常时效内，工匠老师们正在努力修复');
        return
      }
      
      orderApi.reminder(this.id).then((res) => {
        Toast(res);
      })
    },
    
    getDetail() {
      orderApi.speedMsg(this.id).then((res) => {
        if (res.firstExpectEndDate) {
          let arr = (res.firstExpectEndDate.split(' '))[0].split('-')
          let str = arr[1] + '月' + arr[2] + '日'
          res.endTime = str
        }
        this.detail = res;
        this.speedList = res.goodsServiceProgressVOS.map(item => {
          item.goodsTechnics.map(item2 => {
            item2.detailShow = false
            return item2
          })
          return item
        })
      })
    },

    detailShowFn(index, index2) {
      console.log('index', index, index2)
      let arr = JSON.parse(JSON.stringify(this.speedList[index].goodsTechnics))
      arr[index2].detailShow = !arr[index2].detailShow
      this.speedList[index].goodsTechnics = arr
      // this.$set(this.speedList[index],'goodsTechnics',arr)
      // this.speedList[index].goodsTechnics[index2].detailShow = !this.speedList[index].goodsTechnics[index2].detailShow
    }
  }
}
</script>

<style scoped lang="scss">
.myBtn{
  float: right;
  margin-right: 20px;
  display: block;
}
section {
  width: 100%;
  height: 100%;
  background-color: #fafafa;
}
.topTips {
  width: 100%;
  height: 54px;
  background-color: #f24949;
  text-align: center;
  line-height: 54px;
  font-size: 22px;
  color: white;
}
.topMsg {
  width: 100%;
  box-sizing: border-box;
  padding: 90px 60px 26px;
  overflow: hidden;
  font-weight: 500;
  img {
    width: 164px;
    height: 164px;
    display: block;
    float: left;
    border-radius: 8px;
    overflow: hidden;
  }
  .msg {
    width: 440px;
    float: left;
    margin-left: 20px;
    .name {
      font-size: 28px;
      line-height: 40px;
    }
    .speed {
      height: 28px;
      margin: 16px 0 6px;
      overflow: hidden;
      .speedBox {
        width: 356px;
        float: left;
        margin-top: 6px;
        .van-progress {
          height: 16px;
        }
      }
      .speedBox2 {
        width: 356px;
        float: left;
        margin-top: 6px;
        .van-progress {
          height: 16px;
          background-color: #f24949;
        }
      }
      .speedNum {
        line-height: 28px;
        font-size: 20px;
        float: left;
        margin-left: 16px;
      }
    }
    .time {
      font-size: 24px;
      color: #bdbfbf;
      line-height: 34px;
    }
  }
}
.yesColor {
  color: #7adfdf;
}
.content {
  padding: 20px;
  overflow: hidden;
  color: #333333;
  font-weight: 500;
  .firstTitle {
    width: 100%;
    overflow: hidden;
    .firstComplete {
      width: 20px;
      height: 20px;
      display: block;
      line-height: 34px;
      float: left;
      margin-top: 4px;
    }
    .text {
      float: right;
      width: 670px;
      font-size: 24px;
      line-height: 34px;
    }
  }
  .secondBigBox {
    width: 702px;
    box-sizing: border-box;
    margin-left: 8px;
    border-left: 2px dashed #d8d8d8;
    padding-left: 30px;
    padding-top: 16px;
    .secondBox {
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 2px 20px -4px rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      box-sizing: border-box;
      padding: 0 32px;
      .title {
        width: 100%;
        padding: 24px 0;
        box-sizing: border-box;
        line-height: 40px;
        overflow: hidden;
        .leftName {
          font-size: 28px;
          float: left;
        }
        img {
          width: 26px;
          height: 16px;
          display: block;
          float: right;
          margin-top: 12px;
          transition: 0.25s;
        }
        .imgRotate {
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          -o-transform: rotate(180deg);
          -ms-transform: rotate(180deg);
          transform: rotate(180deg);
        }
        .rightName {
          float: right;
          margin-right: 22px;
        }
        .textGray{
          color: #D6D6D6;
        }
        .textRed{
          color: #F24949;
        }
      }
      .thirdBigBox {
        width: 100%;
        padding-top: 8px;
        .thirdBox {
          width: 100%;
          .thirdTitle {
            width: 100%;
            overflow: hidden;
            .thirdImg {
              width: 26px;
              height: 26px;
              display: block;
              float: left;
            }
            .thirdText {
              float: left;
              margin-left: 14px;
              font-size: 24px;
              line-height: 34px;
            }
          }
          .thirdTips {
            margin-left: 11px;
            width: 595px;
            box-sizing: border-box;
            border-left: 2px dashed #d8d8d8;
            padding: 6px 0 42px 27px;
            font-size: 22px;
            color: #bdbfbf;
            line-height: 32px;
          }
          .thirdTips_last {
            margin-left: 11px;
            width: 595px;
            box-sizing: border-box;
            padding: 6px 0 24px 27px;
            font-size: 22px;
            color: #bdbfbf;
            line-height: 32px;
          }
        }
      }
    }
  }
  .secondBigBox_last {
    border-left: none;
  }
}
.myBox .secondBigBox:nth-last-child(1) {
  padding-bottom: 40px;
}
</style>
